import React, { useRef } from "react";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import styles from "../../../styles/pages/user/memberpartner/memberpartner-dashboard.module.scss";
import {
  Box,
  List,
  ListItem,
  Stack,
  Tab,
  Tabs,
  Typography,
  alpha,
  styled,
} from "@mui/material";
import PendingPublicationIcon from "../../../public/assets/icons/PendingPublicationIcon";
import OpenMessageIcon from "../../../public/assets/icons/OpenMessageIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditorDashboardTable from "../../../components/Error/EditorDashboardTable/EditorDashboardTable";
import CalenderIcon from "../../../public/assets/icons/CalenderIcon";
import ApproveIconGreen from "../../../ui/Icons/ApproveIconGreen";
import RejectedVideoIcon from "../../../public/assets/icons/RejectedVideoIcon";
import DuplicateVideoICon from "../../../ui/Icons/DuplicateVideoICon";
import SubmittedVideoIcon from "../../../public/assets/icons/SubmittedVideoIcon";
import MemberPartnerDashBoardTable from "../../../components/MemberPartnerDashBoardTable/MemberPartnerDashBoardTable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VideoPlayIcon from "../../../ui/Icons/VideoPlayIcon";
import CrossNotificationIcon from "../../../ui/Icons/CrossNotificationIcon";
import useFetch, { usePost } from "../../../hooks/api/useFetch";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import useCalenderFilter from "../../../hooks/useCalenderFilter";
import CalenderDate from "../../Calender";
import { useEffect } from "react";
import dayjs from "dayjs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { getUtcDate } from "../../../lib/functions/utils.lib";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: "auto",
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "&.MuiButtonBase-root": {
        color: "#000",
        fontSize: "14px",
      },
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const MemberPartnerDashboard = () => {
  const [value, setValue] = React.useState(0);

  // const notify = () =>
  //   toast(
  //     <>
  //       <Box className={styles.notificationMain}>
  //         <Box className={styles.notificationMainImg}>
  //           <VideoPlayIcon />
  //         </Box>

  //         <Box className={styles.notificationMainTxt}>
  //           <Typography variant="body1">
  //             New video submission received. <strong>(VSID #5587)</strong>.
  //           </Typography>
  //           <Typography variant="body2">Just Now</Typography>
  //         </Box>
  //       </Box>
  //     </>,
  //     {
  //       className: "toast-red-bk",
  //       autoClose: false,
  //       position: toast.POSITION.BOTTOM_RIGHT,
  //     }
  //   );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //calender functions
  const calenderId = "calendar-input-home";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderId,
  });
  const [filterParams, setFilterParams] = React.useState({
    has_note: "",
    show_potential_duplicates: "",
    unreachable_submitter: "",
    people_appearing: "",
    person_who_filmed: "",
    submit_other_website: "",
    aggrement_with_another_company: "",
    filter_active: false,
  });
  useEffect(() => {
    const startDate = dayjs(confirmedCalenderValue?.[0]).format("DD-MM-YYYY");
    const endDate = dayjs(confirmedCalenderValue?.[1]).format("DD-MM-YYYY");
    // setCalenderDate({ from: startDate, to: endDate });
  }, [confirmedCalenderValue]);

  /*************************************/

  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (value) => {
    setAnchorEl(null);
    navigate(`/member-partner-dashboard/message?text=${value}`);
    console.log("value here is found", value);
  };

  const [dateIsCurrent, setDateIsCurrent] = useState({});
  console.log("currentDate is here", dateIsCurrent);

  // Format the date as "DD-MM-YYYY"
  const currentDate = new Date();
  const formattedDate =
    ("0" + currentDate.getDate()).slice(-2) +
    "-" +
    ("0" + (currentDate.getMonth() + 1)).slice(-2) +
    "-" +
    currentDate.getFullYear();

  // partnerDataLoad
  const {
    data: managerSubmissionsData,
    isLoading: managerLoading,
    isSuccess: managerSubmissionsIsSuccess,
    isFetching,
  } = usePost(["manager-partner-submissions"], "member_partner/submissions");

  // get today Data
  const {
    data: todayData,
    isLoading: todayDataLoading,
    isSuccess: todayDataIsSuccess,
    isFetching: todayFetching,
  } = usePost(["manager-partner-today"], "member_partner/submissions", {
    from: formattedDate,
    to: formattedDate,
  });

  console.warn("todayData", todayData?.data?.data?.submissions);

  // partnerDataLoad

  // open message
  const {
    data: messages,
    isLoading,
    isSuccess,
    isError,
  } = useFetch(["messages"], `inquiries?open_message=yes`);

  const currentRef = useRef();
  const [tabId, setTabId] = useState(0);

  const handelClick = (id) => {
    setTabId(id);
    if (id === 0) {
      navigate(`/member-partner-dashboard/my-videos-approved#pending`);
    }
    if (id === 1) {
      navigate(`/member-partner-dashboard/my-videos-approved#approved`);
    }
    if (id === 2) {
      navigate(`/member-partner-dashboard/my-videos-approved#rejected`);
    }
    if (id === 3) {
      navigate(`/member-partner-dashboard/my-videos-approved#duplicate`);
    }
  };
  const handelMessage = (id) => {
    navigate(`/member-partner-dashboard/message`);
  };
  const date = new Date();

  return (
    <MemberPartnerDashboardWrapper tab={tabId} chatbtn>
      <ApiLoader loading={managerLoading || isFetching} />
      <Box className={styles.memberPartnerDashboard}>
        <Box className={styles.editorDashboardWrapper}>
          <Box className={styles.editorTab}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                style={{
                  border: value === 0 ? "2px solid #111AE9" : "none",
                }}
                className={styles.tabItemSubmitted}
                label={
                  <>
                    <Box className={`${styles.tabItem}`}>
                      <Box className={styles.tabitemImg}>
                        <SubmittedVideoIcon />
                      </Box>

                      <p>
                        Submitted Videos{" "}
                        <span>
                          {managerSubmissionsData?.data?.data?.submissions
                            ?.submitted_videos
                            ? managerSubmissionsData?.data?.data?.submissions
                                ?.submitted_videos
                            : "_"}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(0)}
              />
              <Tab
                style={{
                  border: value === 1 ? "2px solid #111AE9" : "none",
                }}
                className={styles.tabItemPending}
                label={
                  <>
                    <Box
                      className={`${styles.tabItem}`}
                      onClick={() => handelClick(0)}
                    >
                      <Box className={styles.tabitemImg}>
                        <PendingPublicationIcon />
                      </Box>

                      <p>
                        Pending Review{" "}
                        <span>
                          {managerSubmissionsData?.data?.data?.submissions
                            ?.pending_videos
                            ? managerSubmissionsData?.data?.data?.submissions
                                ?.pending_videos
                            : "_"}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(1)}
              />
              <Tab
                style={{
                  border: value === 2 ? "2px solid #111AE9" : "none",
                }}
                className={styles.tabItemApprove}
                label={
                  <>
                    <Box
                      className={`${styles.tabItem}`}
                      onClick={() => handelClick(1)}
                    >
                      <Box className={styles.tabitemImg}>
                        <ApproveIconGreen />
                      </Box>

                      <p>
                        Approved Videos{" "}
                        <span>
                          {managerSubmissionsData?.data?.data?.submissions
                            ?.approved
                            ? managerSubmissionsData?.data?.data?.submissions
                                ?.approved
                            : "_"}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(2)}
              />
              <Tab
                style={{
                  border: value === 3 ? "2px solid #111AE9" : "none",
                }}
                className={styles.tabItemRejected}
                label={
                  <>
                    <Box
                      className={`${styles.tabItem}`}
                      onClick={() => handelClick(2)}
                    >
                      <Box className={styles.tabitemImg}>
                        <RejectedVideoIcon />
                      </Box>

                      <p>
                        Rejected Videos{" "}
                        <span>
                          {managerSubmissionsData?.data?.data?.submissions
                            ?.rejected
                            ? managerSubmissionsData?.data?.data?.submissions
                                ?.rejected
                            : "_"}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(3)}
              />
              <Tab
                style={{
                  border: value === 4 ? "2px solid #111AE9" : "none",
                }}
                className={styles.tabItemDuplicated}
                label={
                  <>
                    <Box
                      className={`${styles.tabItem}`}
                      onClick={() => handelClick(3)}
                    >
                      <Box className={styles.tabitemImg}>
                        <DuplicateVideoICon />
                      </Box>

                      <p>
                        Duplicated Videos{" "}
                        <span>
                          {managerSubmissionsData?.data?.data?.submissions
                            ?.duplicate_videos
                            ? managerSubmissionsData?.data?.data?.submissions
                                ?.duplicate_videos
                            : "_"}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(4)}
              />
              <Tab
                style={{
                  border: value === 5 ? "2px solid #111AE9" : "none",
                }}
                className={styles.tabItemMessage}
                label={
                  <>
                    <Box
                      className={`${styles.tabItem}`}
                      onClick={handelMessage}
                    >
                      <Box className={styles.tabitemImg}>
                        <OpenMessageIcon />
                      </Box>

                      <p>
                        Open Messages{" "}
                        <span>
                          {managerSubmissionsData?.data?.data?.submissions
                            ?.submitted_videos
                            ? managerSubmissionsData?.data?.data?.submissions
                                ?.open_message
                            : "_"}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(5)}
              />
            </Tabs>
          </Box>

          <Box className={styles.copywriterBody}>
            <PerfectScrollbar>
              <CustomTabPanel value={value} index={0}>
                <Box className={styles.copywriterTabTitling}>
                  <Box className={styles.TitlingLeft}>
                    <Box className={styles.titlingList}>
                      <Box className={styles.titlingListItem}>
                        <Box
                          className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                        >
                          <Box className={styles.titlingListBoxHeader}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                              className={styles.formcontrolSearch}
                            >
                              <h4>
                                Open Messages{" "}
                                <span>{messages?.data?.meta?.total}</span>
                              </h4>
                              <Button
                                id="demo-customized-button"
                                aria-controls={
                                  open ? "demo-customized-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                variant="contained"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                              >
                                See all
                              </Button>
                              <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                  "aria-labelledby": "demo-customized-button",
                                }}
                                anchorEl={anchorEl}
                                open={open}
                              >
                                <MenuItem
                                  onClick={() => handleClose("Pending")}
                                  disableRipple
                                >
                                  Pending
                                </MenuItem>
                                <MenuItem
                                  onClick={() => handleClose("Need to replay")}
                                  disableRipple
                                >
                                  Need to replay
                                </MenuItem>
                              </StyledMenu>
                            </Stack>
                          </Box>
                          <Box className={styles.titlingListBoxBody}>
                            {/* <PerfectScrollbar> */}
                            <Box className={styles.titlingListBoxItemMain}>
                              {isLoading ? (
                                <ApiLoader loading={isLoading} />
                              ) : isSuccess && messages?.data?.meta?.total ? (
                                <MemberPartnerDashBoardTable
                                  message={messages?.data?.data}
                                  isLoading={isLoading}
                                />
                              ) : (
                                ""
                              )}
                            </Box>
                            {/* </PerfectScrollbar> */}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.TitlingRight}>
                    <Box className={styles.TitlingRightDate}>
                      <Box className={styles.TitlingRightDateTxt}>
                        <Typography>
                          Showing Data for{" "}
                          <span style={{ color: "blue" }}>Today</span>
                          <div>({getUtcDate(date)})</div>
                          {/* {calenderFilter?.name?.length
                            ? ""
                            : "the period from"} */}
                        </Typography>
                        <Typography className={styles.TitlingRightDateTxtDate}>
                          {/* calender */}
                          {/* {filterParams?.filter_active
                            ? "one or more selected filters"
                            : calenderFilter?.name?.length
                            ? `(${dayjs(confirmedCalenderValue?.[0]).format(
                                "LL"
                              )} - ${dayjs(confirmedCalenderValue?.[1]).format(
                                "LL"
                              )})`
                            : `(${dayjs(confirmedCalenderValue?.[0]).format(
                                "LL"
                              )} - ${dayjs(confirmedCalenderValue?.[1]).format(
                                "LL"
                              )})`} */}
                          {/* calender */}
                        </Typography>
                      </Box>
                      <Box className={styles.TitlingRightDateImg}>
                        {/* calender */}
                        {/* <div style={{ marginLeft: "10px" }}>
                          <CalenderDate confirmCalender={confirmCalenderTwo} />
                        </div> */}
                        {/* calender */}
                      </Box>
                    </Box>
                    <Box className={styles.videoTitlingSummary}>
                      <Typography variant="h4">
                        Video Submission Summary
                      </Typography>
                      <List>
                        <ListItem>
                          Submitted Videos{" "}
                          <span>
                            {" "}
                            {todayData?.data?.data?.submissions
                              ?.submitted_videos
                              ? todayData?.data?.data?.submissions
                                  ?.submitted_videos
                              : "_"}
                          </span>
                        </ListItem>
                        <ListItem>
                          Pending Review{" "}
                          <span>
                            {" "}
                            {todayData?.data?.data?.submissions?.pending_videos
                              ? todayData?.data?.data?.submissions
                                  ?.pending_videos
                              : "_"}
                          </span>
                        </ListItem>
                        <ListItem>
                          Approved Videos{" "}
                          <span>
                            {" "}
                            {todayData?.data?.data?.submissions?.approved
                              ? todayData?.data?.data?.submissions?.approved
                              : "_"}
                          </span>
                        </ListItem>
                        <ListItem>
                          Rejected Videos{" "}
                          <span>
                            {" "}
                            {todayData?.data?.data?.submissions?.rejected
                              ? todayData?.data?.data?.submissions?.rejected
                              : "_"}
                          </span>
                        </ListItem>
                        <ListItem>
                          Duplicated Videos{" "}
                          <span>
                            {" "}
                            {todayData?.data?.data?.submissions
                              ?.duplicate_videos
                              ? todayData?.data?.data?.submissions
                                  ?.duplicate_videos
                              : "_"}
                          </span>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </Box>
              </CustomTabPanel>

              {/* <CustomTabPanel value={value} index={1}>
                <Box className={styles.copywriterTabTitling}>
                  <Box className={styles.TitlingLeft}>
                    <Box className={styles.titlingList}>
                      <Box className={styles.titlingListItem}>
                        <Box
                          className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                        >
                          <Box className={styles.titlingListBoxHeader}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                              className={styles.formcontrolSearch}
                            >
                              <h4>
                                Open Messages <span>1200</span>
                              </h4>
                              <Button
                                id="demo-customized-button"
                                aria-controls={
                                  open ? "demo-customized-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                variant="contained"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                              >
                                See all
                              </Button>
                              <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                  "aria-labelledby": "demo-customized-button",
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                              >
                                <MenuItem onClick={handleClose} disableRipple>
                                  Edit
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Duplicate
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Archive
                                </MenuItem>
                              </StyledMenu>
                            </Stack>
                          </Box>
                          <Box className={styles.titlingListBoxBody}>
                   
                            <Box className={styles.titlingListBoxItemMain}>
                              <MemberPartnerDashBoardTable />
                            </Box>
                   
                          </Box>
                        </Box>

                 
                      </Box>
                    </Box>
                  </Box>

                  <Box className={styles.TitlingRight}>
                    <Box className={styles.TitlingRightDate}>
                      <Box className={styles.TitlingRightDateTxt}>
                        <Typography>
                          Showing Data for <span>Today</span>
                        </Typography>
                        <Typography className={styles.TitlingRightDateTxtDate}>
                          (April 22, 2023)
                        </Typography>
                      </Box>

                      <Box className={styles.TitlingRightDateImg}>
                        <Button>
                          <CalenderIcon />
                        </Button>
                      </Box>
                    </Box>

                    <Box className={styles.videoTitlingSummary}>
                      <Typography variant="h4">
                        Video Submission Summary
                      </Typography>
                      <List>
                        <ListItem>
                          Submitted Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Pending Review <span>200</span>
                        </ListItem>
                        <ListItem>
                          Approved Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Rejected Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Duplicated Videos <span>200</span>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </Box>
              </CustomTabPanel> */}
              {/* 
              <CustomTabPanel value={value} index={2}>
                <Box className={styles.copywriterTabTitling}>
                  <Box className={styles.TitlingLeft}>
                    <Box className={styles.titlingList}>
                      <Box className={styles.titlingListItem}>
                        <Box
                          className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                        >
                          <Box className={styles.titlingListBoxHeader}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                              className={styles.formcontrolSearch}
                            >
                              <h4>
                                Open Messages <span>1200</span>
                              </h4>
                              <Button
                                id="demo-customized-button"
                                aria-controls={
                                  open ? "demo-customized-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                variant="contained"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                              >
                                See all
                              </Button>
                              <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                  "aria-labelledby": "demo-customized-button",
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                              >
                                <MenuItem onClick={handleClose} disableRipple>
                                  Edit
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Duplicate
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Archive
                                </MenuItem>
                              </StyledMenu>
                            </Stack>
                          </Box>
                          <Box className={styles.titlingListBoxBody}>
                   
                            <Box className={styles.titlingListBoxItemMain}>
                              <MemberPartnerDashBoardTable />
                            </Box>
                      
                          </Box>
                        </Box>

               
                      </Box>
                    </Box>
                  </Box>

                  <Box className={styles.TitlingRight}>
                    <Box className={styles.TitlingRightDate}>
                      <Box className={styles.TitlingRightDateTxt}>
                        <Typography>
                          Showing Data for <span>Today</span>
                        </Typography>
                        <Typography className={styles.TitlingRightDateTxtDate}>
                          (April 22, 2023)
                        </Typography>
                      </Box>

                      <Box className={styles.TitlingRightDateImg}>
                        <Button>
                          <CalenderIcon />
                        </Button>
                      </Box>
                    </Box>

                    <Box className={styles.videoTitlingSummary}>
                      <Typography variant="h4">
                        Video Submission Summary
                      </Typography>
                      <List>
                        <ListItem>
                          Submitted Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Pending Review <span>200</span>
                        </ListItem>
                        <ListItem>
                          Approved Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Rejected Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Duplicated Videos <span>200</span>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </Box>
              </CustomTabPanel> */}
              {/* 
              <CustomTabPanel value={value} index={3}>
                <Box className={styles.copywriterTabTitling}>
                  <Box className={styles.TitlingLeft}>
                    <Box className={styles.titlingList}>
                      <Box className={styles.titlingListItem}>
                        <Box
                          className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                        >
                          <Box className={styles.titlingListBoxHeader}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                              className={styles.formcontrolSearch}
                            >
                              <h4>
                                Open Messages <span>1200</span>
                              </h4>
                              <Button
                                id="demo-customized-button"
                                aria-controls={
                                  open ? "demo-customized-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                variant="contained"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                              >
                                See all
                              </Button>
                              <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                  "aria-labelledby": "demo-customized-button",
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                              >
                                <MenuItem onClick={handleClose} disableRipple>
                                  Edit
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Duplicate
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Archive
                                </MenuItem>
                              </StyledMenu>
                            </Stack>
                          </Box>
                          <Box className={styles.titlingListBoxBody}>
                      
                            <Box className={styles.titlingListBoxItemMain}>
                              <MemberPartnerDashBoardTable />
                            </Box>
                   
                          </Box>
                        </Box>

                      </Box>
                    </Box>
                  </Box>

                  <Box className={styles.TitlingRight}>
                    <Box className={styles.TitlingRightDate}>
                      <Box className={styles.TitlingRightDateTxt}>
                        <Typography>
                          Showing Data for <span>Today</span>
                        </Typography>
                        <Typography className={styles.TitlingRightDateTxtDate}>
                          (April 22, 2023)
                        </Typography>
                      </Box>

                      <Box className={styles.TitlingRightDateImg}>
                        <Button>
                          <CalenderIcon />
                        </Button>
                      </Box>
                    </Box>

                    <Box className={styles.videoTitlingSummary}>
                      <Typography variant="h4">
                        Video Submission Summary
                      </Typography>
                      <List>
                        <ListItem>
                          Submitted Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Pending Review <span>200</span>
                        </ListItem>
                        <ListItem>
                          Approved Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Rejected Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Duplicated Videos <span>200</span>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </Box>
              </CustomTabPanel> */}

              {/* <CustomTabPanel value={value} index={4}>
                <Box className={styles.copywriterTabTitling}>
                  <Box className={styles.TitlingLeft}>
                    <Box className={styles.titlingList}>
                      <Box className={styles.titlingListItem}>
                        <Box
                          className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                        >
                          <Box className={styles.titlingListBoxHeader}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                              className={styles.formcontrolSearch}
                            >
                              <h4>
                                Open Messages <span>1200</span>
                              </h4>
                              <Button
                                id="demo-customized-button"
                                aria-controls={
                                  open ? "demo-customized-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                variant="contained"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                              >
                                See all
                              </Button>
                              <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                  "aria-labelledby": "demo-customized-button",
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                              >
                                <MenuItem onClick={handleClose} disableRipple>
                                  Edit
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Duplicate
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Archive
                                </MenuItem>
                              </StyledMenu>
                            </Stack>
                          </Box>
                          <Box className={styles.titlingListBoxBody}>
  
                            <Box className={styles.titlingListBoxItemMain}>
                              <MemberPartnerDashBoardTable />
                            </Box>
              
                          </Box>
                        </Box>

                      </Box>
                    </Box>
                  </Box>

                  <Box className={styles.TitlingRight}>
                    <Box className={styles.TitlingRightDate}>
                      <Box className={styles.TitlingRightDateTxt}>
                        <Typography>
                          Showing Data for <span>Today</span>
                        </Typography>
                        <Typography className={styles.TitlingRightDateTxtDate}>
                          (April 22, 2023)
                        </Typography>
                      </Box>

                      <Box className={styles.TitlingRightDateImg}>
                        <Button>
                          <CalenderIcon />
                        </Button>
                      </Box>
                    </Box>

                    <Box className={styles.videoTitlingSummary}>
                      <Typography variant="h4">
                        Video Submission Summary
                      </Typography>
                      <List>
                        <ListItem>
                          Submitted Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Pending Review <span>200</span>
                        </ListItem>
                        <ListItem>
                          Approved Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Rejected Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Duplicated Videos <span>200</span>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </Box>
              </CustomTabPanel> */}

              {/* <CustomTabPanel value={value} index={5}>
                <Box className={styles.copywriterTabTitling}>
                  <Box className={styles.TitlingLeft}>
                    <Box className={styles.titlingList}>
                      <Box className={styles.titlingListItem}>
                        <Box
                          className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
                        >
                          <Box className={styles.titlingListBoxHeader}>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                              className={styles.formcontrolSearch}
                            >
                              <h4>
                                Open Messages <span>1200</span>
                              </h4>
                              <Button
                                id="demo-customized-button"
                                aria-controls={
                                  open ? "demo-customized-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                variant="contained"
                                disableElevation
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                              >
                                See all
                              </Button>
                              <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                  "aria-labelledby": "demo-customized-button",
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                              >
                                <MenuItem onClick={handleClose} disableRipple>
                                  Edit
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Duplicate
                                </MenuItem>
                                <MenuItem onClick={handleClose} disableRipple>
                                  Archive
                                </MenuItem>
                              </StyledMenu>
                            </Stack>
                          </Box>
                          <Box className={styles.titlingListBoxBody}>
                      
                            <Box className={styles.titlingListBoxItemMain}>
                              <MemberPartnerDashBoardTable />
                            </Box>
                   
                          </Box>
                        </Box>

                      </Box>
                    </Box>
                  </Box>

                  <Box className={styles.TitlingRight}>
                    <Box className={styles.TitlingRightDate}>
                      <Box className={styles.TitlingRightDateTxt}>
                        <Typography>
                          Showing Data for <span>Today</span>
                        </Typography>
                        <Typography className={styles.TitlingRightDateTxtDate}>
                          (April 22, 2023)
                        </Typography>
                      </Box>

                      <Box className={styles.TitlingRightDateImg}>
                        <Button>
                          <CalenderIcon />
                        </Button>
                      </Box>
                    </Box>

                    <Box className={styles.videoTitlingSummary}>
                      <Typography variant="h4">
                        Video Submission Summary
                      </Typography>
                      <List>
                        <ListItem>
                          Submitted Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Pending Review <span>200</span>
                        </ListItem>
                        <ListItem>
                          Approved Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Rejected Videos <span>200</span>
                        </ListItem>
                        <ListItem>
                          Duplicated Videos <span>200</span>
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </Box>
              </CustomTabPanel> */}
            </PerfectScrollbar>
          </Box>
        </Box>
      </Box>
      <ToastContainer />
    </MemberPartnerDashboardWrapper>
  );
};

export default MemberPartnerDashboard;
